import { safeColor } from './utils.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
function getGradients(colors) {
  return {
    basic: {
      background: "linear-gradient(90deg, transparent, ".concat(colors.neutrals[17], ", transparent)")
    },
    primary: {
      background: "linear-gradient(90deg, transparent, ".concat(safeColor(colors.primary), ", transparent)")
    }
  };
}

export default getGradients;
//# sourceMappingURL=gradients.esm.js.map
